export const appInitialState = {
    app: {
        navigationMenuIsVisible: false,
        startArrowIsVisible: false,
        productDetailsModalIsVisible: false,
        printSummaryModalIsVisible: false,
        emailSummaryModalIsVisible: false,
        alertModalIsVisible: false,
        onlyDropdownIsVisible: false,
        optionsMenuIsVisible: false,
        previewIsVisible: false,
        // exitPreviewBtnIsVisible: false,
        scrollDownTooltipIsVisible: true,
    },
    catalog: {
        currentCategoryId: 'generators',
        renderMode: 'expanded', // Options: compact, expanded
        cartProductsIds: []
    },
    router: {
        path: window.location.pathname + window.location.search
    }
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/state/app-initial-state.ts